import { Link } from "react-router-dom";
import styled from "styled-components";

export const BrandRow = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 16,
  paddingTop: 20,
  marginBottom: 24,

  [theme.down("sm")]: {
    justifyContent: "center",
  },
}));

export const BrandLogo = styled("img")(({ theme }) => ({
  width: 55,
  height: 55,
  borderRadius: 10,
  objectFit: "contain",
}));

export const BrandName = styled("p")(({ theme }) => ({
  fontSize: 30,
  fontWeight: 700,
  color: theme.palette.white,

  [theme.down("md")]: {
    fontSize: 20,
  },
}));

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.paddings(10, 0, 40, 0),
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: 30,

  [theme.down("md")]: {
    flexDirection: "column",
    gap: 20,
    alignItems: "center",
    justifyContent: "center",
  },
}));

export const LinksBlock = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr",
  gap: 30,
  flexGrow: 3,

  [theme.upDown("xs", "sm")]: {
    flexGrow: 1,
    gridTemplateColumns: "1fr",
    textAlign: "center",
  },

  [theme.down("md")]: {
    gap: 20,
  },

  [theme.down("xs")]: {
    flexGrow: 1,
    gridTemplateColumns: "1fr",
    textAlign: "center",
  },
}));

export const LegalInformation = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",

  "& > h2": {
    fontSize: 22,
    fontWeight: 700,
    marginBottom: 15,

    [theme.down("sm")]: {
      fontSize: 16,
    },
  },
}));

export const Deals = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",

  "& > h2": {
    fontSize: 22,
    fontWeight: 700,
    marginBottom: 15,

    [theme.down("sm")]: {
      fontSize: 16,
    },
  },
}));

export const About = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",

  "& > h2": {
    fontSize: 22,
    fontWeight: 700,
    marginBottom: 15,

    [theme.down("sm")]: {
      fontSize: 16,
    },
  },
}));

export const Opportunities = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",

  "& > h2": {
    fontSize: 22,
    fontWeight: 700,
    marginBottom: 15,

    [theme.down("sm")]: {
      fontSize: 16,
    },
  },
}));

export const LinkItem = styled(props => (
  <div>
    <Link {...props} />
  </div>
))(({ theme }) => ({
  display: "inline-block",
  width: "fit-content",
  fontSize: 15,
  lineHeight: "30px",
  color: theme.palette.white,
  transition: "transform .3s ease-in-out",

  "&:hover": {
    transform: "translateX(8px)",
  },
}));

export const SocialsLink = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  marginTop: 10,
  gap: 15,

  "& > firstChild": {
    marginLeft: "-5px",
  },

  [theme.down("sm")]: {
    justifyContent: "center",
  },
}));

export const Socials = styled("img")(({ theme }) => ({
  width: "40px",
  height: "40px",
}));

export const LogosBlock = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 10,
  flexGrow: 2,

  [theme.down("sm")]: {
    flexGrow: 1,
    flexWrap: "wrap",
    justifyContent: "center",
  },

  "& > div": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export const PaymentsLogo = styled("img")(({ theme }) => ({
  width: "100%",
  maxWidth: 150,
  height: "auto",
}));

export const IataLogo = styled("img")(({ theme }) => ({
  marginTop: -8,
  width: 85,
  height: 28,
}));

export const TkpLogo = styled("img")(({ theme }) => ({
  width: 71,
  height: 39,
}));

export const CopyRight = styled("p")(({ theme }) => ({
  fontSize: 16,
  color: theme.palette.white,
  lineHeight: "17px",
  textAlign: "center",

  [theme.down("sm")]: {
    fontSize: 14,
  },
}));

export const CardLogosRow = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "8px",
  alignItems: "center",
  flexWrap: "wrap",
  justifyContent: "center",
}));

export const CardLogo = styled("img")(({ theme }) => ({
  height: "28px",
  objectFit: "contain",
}));

export const CompanyInfoRow = styled("div")(({ theme }) => ({
  fontSize: 14,
  textAlign: "center",
  color: theme.palette.white,
  padding: "30px 16px",
  borderTop: "1px solid rgba(255, 255, 255, 0.8)",
  margin: 0,
  marginTop: 20,
  lineHeight: 1.6,
}));
